import {
  NewPasswordRequest,
  postNewPassword,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleSuccess, Self } from '../common';

function* newPasswordRequest(
  self: Self,
  body: NewPasswordRequest,
  goToLogin: () => void
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield postNewPassword(body);
    const { status } = (response as SuccessResponse).data;
    if (status.code === 1000) {
      return handleSuccess(self, response as SuccessResponse);
    }
    self.alert.title = 'The recovery link is expired';
    self.alert.message =
      'Please contact TFSPH Merchant call center to send you another invitation';
    self.alert.handleOK = goToLogin;
    self.alert.open = true;
    return Promise.reject(ResponseMessage.Error);
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default newPasswordRequest;
